import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlSegment } from '@angular/router';
import { RegexUrlMatcher } from '@app/shared/model/classes/regex-url-matcher';
import { ProductUnloadGuard } from './product-unload.guard';
import { ProductComponent } from './product.component';
import { IsLoggedGuard } from '@app/shared/guards';
import { ProductPageResolver } from './resolvers/product-page.resolver';

export function productMatcher(url: UrlSegment[]) {
  let regexUrlMatcher: RegexUrlMatcher;
  regexUrlMatcher = new RegexUrlMatcher();
  const regExp = new RegExp(/.*\/.*\/.*\/.*-([0-9]+)\.shtml$/);
  return regexUrlMatcher.getRegexUrlMatcherRegexUrlMatcher(url, regExp, ['id']);
}

const productRoutes: Routes = [
  {
    path: '',
    component: ProductComponent,
    canDeactivate: [ProductUnloadGuard, IsLoggedGuard],
    resolve: {
      productPageData: ProductPageResolver
    }
  }
];
@NgModule({
  imports: [RouterModule.forChild(productRoutes)],
  exports: [RouterModule]
})
export class ProductRoutingModule {}
